import { SuccessPage } from "../../components/SuccessPage";
import { Button, Typography } from 'seagull';
import styles from "./AllSetPage.module.scss";
import { isMobileDevice } from "../../../infra/device";
import { Link, useParams } from 'react-router-dom';
import { routes } from "../../../constants";
import SetPasswordIcon from "./setPassword.svg";
import InviteIcon from "./invite.svg";
import UpdateProfileIcon from "./updateProfile.svg";
import ViewTheAgreement from "./viewTheAgreement.svg";
import React from 'react';
import { useStore, useStoreActions } from "../../../store/store-context";
import { useResponsive } from "../../contexts";
import RestfulWrapper from "../../../components/RestfulWrapper/RestfulWrapper";
import CreateAVendorAccountPrompt from "../CreateAVendorAccountPrompt/CreateAVendorAccountPrompt";
function AllSetPageRouted(_ref) {
  let {
    relationship
  } = _ref;
  const {
    logBI
  } = useStoreActions();
  const userInfo = useStore(state => state.userInfo);
  const vendorName = relationship.vendor.name;
  const {
    isDesktop
  } = useResponsive();
  const RecommendedNextSteps = () => {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
      variant: "h6",
      className: styles.nextStepsTitle
    }, "Recommended next steps"), /*#__PURE__*/React.createElement("div", {
      className: styles.nextStepsRow
    }, /*#__PURE__*/React.createElement("a", {
      className: styles.nextStepBlock,
      href: routes.agreement(relationship.id),
      "data-testid": "cob-view-agreement"
    }, /*#__PURE__*/React.createElement(ViewTheAgreement, null), /*#__PURE__*/React.createElement(Typography, null, "View the agreement")), !(userInfo !== null && userInfo !== void 0 && userInfo.identityTypes()) && /*#__PURE__*/React.createElement("a", {
      className: styles.nextStepBlock,
      href: routes.profile,
      "data-testid": "cob-set-password",
      onClick: () => logBI(10831)
    }, /*#__PURE__*/React.createElement(SetPasswordIcon, null), /*#__PURE__*/React.createElement(Typography, null, "Set a password")), /*#__PURE__*/React.createElement("a", {
      className: styles.nextStepBlock,
      href: routes.team,
      "data-testid": "cob-invite-team-members",
      onClick: () => logBI(10830)
    }, /*#__PURE__*/React.createElement(InviteIcon, null), /*#__PURE__*/React.createElement(Typography, null, "Invite your team")), /*#__PURE__*/React.createElement("a", {
      className: styles.nextStepBlock,
      href: routes.businessDetails,
      "data-testid": "cob-update-profile",
      onClick: () => logBI(10832)
    }, /*#__PURE__*/React.createElement(UpdateProfileIcon, null), /*#__PURE__*/React.createElement(Typography, null, "Update business profile"))));
  };
  return /*#__PURE__*/React.createElement(SuccessPage, {
    "data-testid": "cob-all-set",
    className: styles.allSetPageWrapper,
    image: /*#__PURE__*/React.createElement(React.Fragment, null)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.confirmationWrapper
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h3",
    weight: "bold",
    className: styles.thankYouText
  }, "Thank you for signing!"), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "Your agreement with ", vendorName, " has been approved and sent to your email."), isDesktop && /*#__PURE__*/React.createElement(RecommendedNextSteps, null), /*#__PURE__*/React.createElement("div", {
    className: styles.sep
  })), relationship.isSample && !isMobileDevice && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: styles.nextStepsTitle
  }), /*#__PURE__*/React.createElement(Button, {
    as: Link,
    to: routes.home,
    "data-testid": "cob-test-agreement-link"
  }, "Go to Anchor")), /*#__PURE__*/React.createElement(CreateAVendorAccountPrompt, null));
}
function AllSetPageQueryWrapper(props) {
  const {
    relationshipId: relationshipIdParam
  } = useParams();
  const {
    api
  } = useStoreActions();
  const relationshipId = relationshipIdParam || props.relationshipId;
  async function fetchData() {
    if (!relationshipId) {
      throw new Error('No relationshipId provided');
    }
    const [relationship] = await Promise.all([api.relationship.get(relationshipId)]);
    return {
      relationship
    };
  }
  return /*#__PURE__*/React.createElement(RestfulWrapper, {
    fetch: fetchData,
    renderChild: _ref2 => {
      let {
        data
      } = _ref2;
      return /*#__PURE__*/React.createElement(AllSetPageRouted, {
        relationship: data.relationship
      });
    }
  });
}
export default AllSetPageQueryWrapper;